<template>
<div>
<h1> Conducted experiments </h1>

<h2> All Projects </h2>
<div style='display: table; margin-right: auto; margin-left: auto;' v-html='allProjectsInformation'>
</div>
<h2> Number of projects per group </h2>
<div style='display: table; margin-right: auto; margin-left: auto;' v-html='numberOfProjectsPerGroupInformation'>
</div>
<svg id='graphview'></svg>
<Words/>
<br/>
<br/>
<br/>
</div>
</template>

<script>
export default {
  name: 'ExperimentsView',
  props: {
    query_data: Object,
    allProjectsInformation: '',
    numberOfProjectsPerGroupInformation: ''
  },
  data () {
    return {
      data: this.query_data
    }
  },
  mounted () {
    this.generateHTML()
  },
  methods: {
    findOcc (arr, key) {
      let arr2 = []
      arr.forEach((x) => {
        if (arr2.some((val) => { return val[key] === x[key] })) {
          arr2.forEach((k) => {
            if (k[key] === x[key]) {
              k['occurrence']++
            }
          })
        } else {
          let a = {}
          a[key] = x[key]
          a['occurrence'] = 1
          arr2.push(a)
        }
      })
      return arr2
    },

    generateHTML () {
      var allProjectsInformation = `
        <table>
        <tr>
        <th> Experimentator </th>
        <th> Title of experiment </th>
        <th> Tissue type </th>
        </tr>
      `
      this.query_data.forEach(function (item, index) {
        allProjectsInformation = allProjectsInformation.concat(`<tr> <td> ${item.name} </td> <td> ${item.title} </td> <td> ${item.tissue} </td> </tr>`)
      })

      allProjectsInformation = allProjectsInformation.concat(`</table>`)

      var occByName = this.findOcc(this.query_data, 'name')
      var numberOfProjectsPerGroupInformation = `
      <table>
      <tr>
      <th> Name of experimentator </th>
      <th> Number of experiments </th>
      </tr>
      `
      occByName.forEach(function (name, index) {
        numberOfProjectsPerGroupInformation = numberOfProjectsPerGroupInformation.concat(`<tr> <td> ${name.name} </td> <td> ${name.occurrence} </td> </tr>`)
      })
      numberOfProjectsPerGroupInformation = numberOfProjectsPerGroupInformation.concat(`</table>`)
      this.numberOfProjectsPerGroupInformation = numberOfProjectsPerGroupInformation
      this.allProjectsInformation = allProjectsInformation
    }
  }
}
</script>

<style>
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color:  #f48990;
  color: white;
}
tr:hover {background-color: #f48990; color: black; }
tr:hover:nth-child(even) { background-color: #f48990; color: black; }
tr:nth-child(even){background-color: #f2f2f2}
</style>



// WEBPACK FOOTER //
// src/components/ExperimentsView.vue